import { ONLINE_BOOKING_API_URL } from '@src/globals';
import AuthHelper from '@auth/auth-helper';
import {
  DROPOFF_VERIFICATION,
  DROPOFF_CONSIGNMENT_DETAILS,
  GET_ECNOTE_URL,
  EDIT_SHIPMENT_DETAILS,
  GET_CUSTOM_INVOICE,
  GET_AUTH_LETTER,
  GET_SHIPPING_LABEL,
  RESEND_DROPOFF_SMS_URL,
  WEIGHT_MISMATCH_VALUES,
  GET_WEIGHT_MISMATCH,
  WEIGHT_MISMATCH_PAYMENT,
  PACKAGING_OPTIONS,
  PACKAGING_SEND_PAYMENT_LINK,
  UPDATE_PACKAGING_MATERIAL_DATA,
  EDIT_DETAILS_PAYMENT,
  LOCATION_CHANGE_PAYMENT,
  GET_COMMODITY_DATA,
  FETCH_PRICE_AND_TAT,
  FETCH_INTERNATIONAL_PRICE_AND_TAT,
} from '@network/api.constants';
import { GET, POST } from '@network/api-hander.service';

export const verifyDropoff = async (params: {
  allowDropoff: boolean,
  referenceNumber: string,
  validationCode: string,
  hubCode: string
  isCompletionRequest : boolean,
}) => {
  return GET(`${ONLINE_BOOKING_API_URL}${DROPOFF_VERIFICATION}`, params);
};

export const dropOffConsignmentDetails = async (obj: any) => {
  return POST(`${ONLINE_BOOKING_API_URL}${DROPOFF_CONSIGNMENT_DETAILS}`, obj);
};

export const editShipmentDetails = async (params: {
  reference_number: string,
  isInternational: boolean,
  contentType: string,
  serviceType: string,
  destinationName: string,
  destinationAddressLine1: string,
  destinationAddressLine2: string,
  destinationPincode: string,
  previousDestinationName? : string,
  previousDestinationAddressLine1? : string,
  previousDestinationAddressLine2? : string,
  previousDestinationPincode? : string,
}) => {
  return POST(`${ONLINE_BOOKING_API_URL}${EDIT_SHIPMENT_DETAILS}`, params);
};

export const getPriceAndTat = async (params: any) => {
  const headers = AuthHelper.getAuthenticationHeaders() as {
    Authorization: string;
    'Content-Type': string;
    'organisation-id': any;
    'application-type'?: string;
  };
  headers['application-type'] = 'smartapp';
  return POST(`${ONLINE_BOOKING_API_URL}${FETCH_PRICE_AND_TAT}`, params, undefined, headers);
};

export const getPriceAndTatInternational = async (params: any) => {
  const headers = AuthHelper.getAuthenticationHeaders() as {
    Authorization: string;
    'Content-Type': string;
    'organisation-id': any;
    'application-type'?: string;
  };
  headers['application-type'] = 'smartapp';
  return GET(`${ONLINE_BOOKING_API_URL}${FETCH_INTERNATIONAL_PRICE_AND_TAT}`, params, undefined, headers);
};

export const getCommodityData = async (params: any) => {
  const headers = AuthHelper.getAuthenticationHeaders() as {
    Authorization: string;
    'Content-Type': string;
    'organisation-id': any;
    'application-type'?: string;
  };
  headers['application-type'] = 'smartapp';
  return GET(`${ONLINE_BOOKING_API_URL}${GET_COMMODITY_DATA}`, params, undefined, headers);
};

export const getEcnoteUrl = async (params:{
  referenceNumber?: string,
  referenceNumberList?: Array<string>,
  showPriceInECNote: boolean,
  source: string | null,
}) => {
  return POST(`${ONLINE_BOOKING_API_URL}${GET_ECNOTE_URL}`, params, true);
};

export const locationChangePayment = async (params: {
  referenceNumber: string,
  email: string,
  phoneNumber: string,
}) => {
  return POST(`${ONLINE_BOOKING_API_URL}${LOCATION_CHANGE_PAYMENT}`, params);
};

export const weightMismatchPaymentLink = async (params: {
  consignments: string[],
  email: string,
}) => {
  return POST(`${ONLINE_BOOKING_API_URL}${WEIGHT_MISMATCH_PAYMENT}`, params);
};
export const editDetailsPayment = async (params: {
  referenceNumber: string,
  email: string,
  phoneNumber: string,
}) => {
  return POST(`${ONLINE_BOOKING_API_URL}${EDIT_DETAILS_PAYMENT}`, params);
};

export const getCustomInvoice = async (params:{
  awbno: string | null,
}) => {
  return GET(`${ONLINE_BOOKING_API_URL}${GET_CUSTOM_INVOICE}`, params, 'blob');
};

export const getAuthLetter = async (params:{
  awbno: string | null,
}) => {
  return GET(`${ONLINE_BOOKING_API_URL}${GET_AUTH_LETTER}`, params, 'blob');
};

export const getShippingLabelUrl = async (params:{
  referenceNumbers: Array<string>,
  isSmall: boolean,
}) => {
  return POST(`${ONLINE_BOOKING_API_URL}${GET_SHIPPING_LABEL}`, params, true);
};

export const resendSMS = async (params:{
  referenceNumber: string,
  username: string | null,
}) => {
  return POST(`${ONLINE_BOOKING_API_URL}${RESEND_DROPOFF_SMS_URL}`, params, false);
};
export const weightMismatchValues = async (params: {
  consignments: string[],
}) => {
  return GET(`${ONLINE_BOOKING_API_URL}${WEIGHT_MISMATCH_VALUES}`, params);
};
export const getWeightMismatchSubmit = async (params: {
  consignments: any,
}) => {
  return POST(`${ONLINE_BOOKING_API_URL}${GET_WEIGHT_MISMATCH}`, params);
};

export const getPackageOptions = async (params: Record<any, any>) => {
  return GET(`${ONLINE_BOOKING_API_URL}${PACKAGING_OPTIONS}`, params);
};

export const sendPaymentLinks = async (params: Record<any, any>) => {
  return POST(`${ONLINE_BOOKING_API_URL}${PACKAGING_SEND_PAYMENT_LINK}`, params);
};

export const updatePackingMaterialsData = async (params: Record<any, any>) => {
  return POST(`${ONLINE_BOOKING_API_URL}${UPDATE_PACKAGING_MATERIAL_DATA}`, params);
};

